import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import introduceBanner from '@/assets/img/banner/introduce.jpg';
import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import TabList from '@/components/common/Tab/TabList/TabList';
import CommitteeList from '@/components/Introduce/CommitteeList/CommitteeList';
import ExecutiveList from '@/components/Introduce/ExecutiveList/ExecutiveList';
import History from '@/components/Introduce/History/History';
import IntroduceOwner from '@/components/Introduce/IntroduceOwner/IntroduceOwner';
import Maps from '@/components/Introduce/Maps/Maps';
import Rules from '@/components/Introduce/Rules/Rules';

const Introduce = () => {
	const { t } = useTranslation();
	const location = useLocation();
	const navigate = useNavigate();

	const params = location.state?.menu ?? '학회소개';
	const tabList = ['학회소개', '학회연혁', '정관 및 규정', '임원', '분과위원회', '오시는길'];

	const handleMenuName = (menu: string) => {
		navigate('/introduce', { state: { menu: menu } });
	};

	return (
		<main>
			<SubBanner subTitle="introduce.page.bannerSubtitle" title="introduce.page.bannerTitle" img={introduceBanner} />
			<TabList menuList={tabList} menuKey={params} onListClick={handleMenuName} />
			{params === tabList[0] && <IntroduceOwner />}
			{params === tabList[1] && <History />}
			{params === tabList[2] && <Rules />}
			{params === tabList[3] && <ExecutiveList />}
			{params === tabList[4] && <CommitteeList />}
			{params === tabList[5] && <Maps />}
		</main>
	);
};

export default Introduce;
